import { Helmet } from "react-helmet";
import Home from "./sections/Home/Home";
import About from "./sections/About/About";
import Roadmap from "./sections/Roadmap/Roadmap";
import Navbar from "./components/Navbar/Navbar";
import Social from "./sections/Social/Social";
import Team from "./sections/Team/Team";
import Faq from "./sections/Faq/Faq";
import Mint from "./sections/Mint/Mint";

function App() {
  return (
    <div>
      <Helmet htmlAttributes={{ lang: "en" }}>
        <meta charSet="UTF-8" />
        <title>Cryptogods: Anubis</title>
        <meta
          name="description"
          content=" CryptoGods: Anubis is a collection of 10000 randomly generated NFTs which welcome the Egyptian God of the Dead into the metaverse. CryptoGods: Anubis holders will be a part of the global community which gets access to exclusive events, special giveaways and many bonuses along the journey."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="keywords"
          content="Cryptogod, Anubis, Cryptogod Anubis, Alternate Reality, AR, nft, nfts, opensea, nftcollector, Egyptian gods, Metavarse, crypto, Anubis nft, god of the dead, GOTD, cryptocurrency, blockchain"
        ></meta>
        <meta property="og:image" content="https://www.cryptogodsanubis.com/fb_preview_img.png"></meta>
        <meta property="og:url" content="https://www.cryptogodsanubis.com" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Cryptogods: Anubis" />
        <meta
          property="og:description"
          content=" CryptoGods: Anubis is a collection of 10000 randomly generated NFTs which welcome the Egyptian God of the Dead into the metaverse. CryptoGods: Anubis holders will be a part of the global community which gets access to exclusive events, special giveaways and many bonuses along the journey."
        />
      </Helmet>
      <Navbar />
      <Home />
      <About />
      <Roadmap />
      <Faq />
      <Mint />
      <Team />
      <Social />
      <p className="text-white text-center text-base mb-4">
        Developed by{" "}
        <a
          href="https://www.supraditya.com"
          target="_blank"
          rel="noreferrer"
          className="text-egyptian-gold"
        >
          supraditya
        </a>
      </p>
    </div>
  );
}

export default App;
